Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'chart',
  '.sc-chart',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

  // Widget Declarations
  const $this = $(el);
  const $chart = $this.find(`${selector}__chart`);  
  let myChart = null;

  /**
   * Initialize the widget
   */
  (function init(){    
    render();
    $.breakpoint('change', resize);
  })();

  /**
   * Render the chart
   */
  function render() {    
    
    if(model.data.chartData){
      myChart = echarts.init($chart[0]);
      myChart.setOption(model.data.chartData);
    }
  }

  /**
   * Resize the chart a little after the user has ended the resize
   */
  function resize(){
    if(myChart != null){
      //https://apache.github.io/echarts-handbook/en/concepts/chart-size/
      myChart.resize();
    }
  }
});
